import type {
    ShiftGeneratorTask,
    ShiftGeneratorTaskParams,
} from 'src/api/ShiftGeneratorTaskService';
import { useShiftGeneratorTaskEntry } from '@stores/shiftGeneratorTaskStore';
import { useParams } from 'react-router';

const useShiftGeneratorTask = (
    params?: ShiftGeneratorTaskParams,
): {
    shiftGeneratorTask: ShiftGeneratorTask | undefined;
    departmentId: string | undefined;
    isLoadingShiftGeneratorTask: boolean;
} => {
    const { departmentId, taskId } = useParams<{
        departmentId: string;
        taskId: string;
    }>();

    const {
        response: shiftGeneratorTask,
        isLoading: isLoadingShiftGeneratorTask,
    } = useShiftGeneratorTaskEntry(departmentId, taskId, params);

    return {
        shiftGeneratorTask,
        departmentId,
        isLoadingShiftGeneratorTask,
    };
};

export default useShiftGeneratorTask;
